<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs" :style="divStyle">
      <div class="header-nav container hidden-xs">
        <div class="header-nav-logo">
          <img src="https://1234asdgqwe.oss-cn-beijing.aliyuncs.com/img/logo_black.png" />
        </div>
        <div class="shejiao pull-right" style="border: 1rpx red solid">
          <ul class="header-nav-wrapper">
            <li
              v-for="(item, index) in navList"
              :key="index"
              :class="index == navIndex ? 'active' : ''"
              @click="navClick(index, item.name)"
            >
              <router-link :to="item.path">
                {{ item.name }}
                <span
                  v-if="item.children.length > 0"
                  class="glyphicon glyphicon-menu-down"
                ></span>
                <i class="underline"></i>
              </router-link>
              <dl v-if="item.children.length > 0">
                <dt v-for="(i, n) in item.children" :key="n">
                  <router-link :to="i.path">{{ i.name }}</router-link>
                </dt>
              </dl>
            </li>
          </ul>
        </div>
      </div>
      <!-- 视频 -->
      <video
        v-if="navIndex == 0"
        class="bg-video"
        src="https://1234asdgqwe.oss-cn-beijing.aliyuncs.com/img/首页视频.mp4"
        autoplay
        muted
        loop
        playsinline
        preload="auto"
      >
        <!-- 降级提示（视频无法播放时显示） -->
        您的浏览器不支持视频播放，请升级浏览器
      </video>
      <!-- 背景图 -->
      <div class="bg_img" :style="imgStyle" v-if="navIndex != 0">
        <div :style="imgStyle">
          <div class="title">{{ navList[navIndex].title }}</div>
          <div class="text1">{{ navList[navIndex].text1 }}</div>
          <div class="text2">{{ navList[navIndex].text2 }}</div>
        </div>
      </div>
    </div>

    <!-- 电脑导航 -->
    <!-- <div class="header-nav container hidden-xs">

      <div class="header-nav-logo">
        <img src="@/assets/img/logo_black.png">
      </div>

      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div> -->
    <div style="position: relative"></div>
    <!-- 手机导航 -->
    <!-- <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo_black.png" alt="logo">
      </div>

      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>

        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      // backgroundImageUrl: '../assets/img/banner1.png', // 背景图片的路径
      screenWidth: window.innerWidth, // 初始屏幕宽度
      aspectRatio: 5760 / 1800, // 假设我们想要 div 的高度是宽度的 50%
      aspectRatio2: 1920 / 1080, // 假设我们想要 div 的高度是宽度的 50%
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
          // title: "软件之力，重塑数字乾坤",
          // text1: "科技提高效率",
          // text2: "如果您有想法不如找我们聊聊",
          // img: require("@/assets/img/banner1.png"),
        },
        // {
        //   name: "公司概况",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "电商系统",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "工厂管理系统",
        //       path: "/software/bigData"
        //     }
        //   ]
        // },
        {
          name: "公司概况",
          path: "/companyintroduction",
          children: [],
          title: "品质为基，开拓前行",
          text1: "",
          text2: `自 2021年创立以来，始终专注于核心业务领域，
凭借卓越的专业能力与创新精神，构建起覆盖全国的服务体系。`,
          img: require("@/assets/img/banner2.png"),
        },
        {
          name: "公司业务",
          path: "/service",
          children: [],
          title: "软件之力，重塑数字乾坤",
          text1: "科技提高效率",
          text2: "某某磨具系统已全面上线，最新版本更高效、更便捷、更智能",
          img: require("@/assets/img/banner3.png"),
        },
        // {
        //   name: "新闻动态",
        //   path: "/newsinformation",
        //   children: []
        // },

        {
          name: "诚聘英才",
          path: "/jobchance",
          children: [],
          title: "诚聘英才，共筑未来",
          text1: "",
          text2: `在这个充满机遇与挑战的时代
我们正在寻找志同道合的你，一起开启一段非凡的职业旅程！`,
          img: require("@/assets/img/banner3.png"),
        },
        {
          name: "联系我们",
          path: "/contactusus",
          children: [],
          title: "沟通从这里开始，期待与您携手同行",
          text1: "",
          text2: `在这个充满机遇与挑战的时代
我们正在寻找志同道合的你，一起开启一段非凡的职业旅程！`,
          img: require("@/assets/img/banner3.png"),
        },
      ],
    };
  },
  computed: {
    divStyle() {
      // 计算 div 的样式，包括背景图片和高度
      return {
        backgroundImage: `url('${this.navList[this.navIndex].img}')`,
        backgroundSize: "100% 100%", // 让背景图片覆盖整个 div
        backgroundRepeat: "no-repeat",
        width: "100%", // div 宽度设置为 100%
        position: "relative",
        height:
          this.navIndex != 0
            ? `${this.screenWidth / this.aspectRatio}px`
            : `${this.screenWidth / this.aspectRatio2}px`, // 根据屏幕宽度和宽高比计算高度
      };
    },
    imgStyle() {
      return {
        height: `${this.screenWidth / this.aspectRatio}px`, // 根据屏幕宽度和宽高比计算高度
      };
    },
  },
  mounted() {
    // 监听窗口 resize 事件，以便在屏幕大小变化时更新数据
    window.addEventListener("resize", this.updateScreenWidth);
  },
  beforeDestroy() {
    // 移除事件监听器，避免内存泄漏
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  methods: {
    updateScreenWidth() {
      console.log(11111, window.innerWidth);
      // 更新屏幕宽度数据
      this.screenWidth = window.innerWidth;
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.bg-video {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: 100%;
  height: 100%;
  z-index: -1; /* 层级置于内容下方 */
  object-fit: cover; /* 填充容器，保持比例，裁剪超出部分 */
}
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
  width: 100vw;
}

#header .header-top {
  color: #fff;
  font-size: 12px;
  position: relative;
  z-index: 999;
}

/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav {
  height: 72px;
  position: relative;
  z-index: 99;
}

/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}

/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 127px;
  height: 28px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 72px;
  float: right;
  margin: 0;
  max-width: 800px;
}

/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 5px;
  position: relative;
  width: 112px;
  height: 100%;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #fff;
  font-size: 14px;
  position: relative;
  width: 100%;
  text-align: center;
  display: block;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #f7931e;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #f7931e;
  text-decoration: none;
  /* background: linear-gradient(180.00deg, rgba(247, 147, 30, 0) 0.747%,rgba(247, 147, 30, 0.2) 100%); */
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 112px;
  left: 0;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}

/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #ffffff;
  text-decoration: none;
  border-bottom: 2px solid #f7931e;
  background: linear-gradient(
    180deg,
    rgba(247, 147, 30, 0) 0.747%,
    rgba(247, 147, 30, 0.2) 100%
  );
  width: 100%;
  height: 100%;
  font-size: 14px;
}

/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}

/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}

#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}

@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }

  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }

  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }

  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }

  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}

.bg_img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 10;
  // top: -72px;
  height: 100%;
}

.bg_img > div {
  width: 100%;
  // height: 100%;
  position: relative;
  // padding-top: 125px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  .title {
    font-size: 50px;
  }

  .text1 {
    font-size: 24px;
  }

  .text2 {
    padding-top: 15px;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue